import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';

export default <template>
  <div class='six wide field'>
    <@form.Date @labelName='Date du diagnostic' @propertyName='diagnosisDate' />
  </div>

  <div class='field'>
    <@form.Dropdown
      @labelName='Type de diagnostic'
      @propertyName='diagnosticType'
      @translationKey='medical-history-changed-journal-event.diagnostic-type'
      as |dropdown|
    >
      <dropdown.Item @key='proctitis' />
      <dropdown.Item @key='diverticulitis' />
      <dropdown.Item @key='pancolitis' />
    </@form.Dropdown>
  </div>
  <div class='field'>
    <@form.Dropdown
      @labelName='Extension cumulée de la maladie'
      @propertyName='cumulativeSpreadDisease'
      @translationKey='medical-history-changed-journal-event.cumulative-spread-disease'
      as |dropdown|
    >
      <dropdown.Item @key='proctite' />
      <dropdown.Item @key='left_colitis' />
      <dropdown.Item @key='extensive_colitis' />
      <dropdown.Item @key='unknown' />
    </@form.Dropdown>
  </div>
  {{#unless @patient.healthCentre.lgcEnabled}}
    <div class='field'>
      <@form.Dropdown
        @labelName='Activité de la maladie'
        @propertyName='diseaseActivity'
        @translationKey='medical-history-changed-journal-event.disease-activity'
        as |dropdown|
      >
        <dropdown.Item @key='inactive' />
        <dropdown.Item @key='weak' />
        <dropdown.Item @key='moderate' />
        <dropdown.Item @key='severe' />
      </@form.Dropdown>
    </div>
  {{/unless}}
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}>;
